export enum ChatbotAssistantKind {
  LEAD_COLLECTOR = "LEAD_COLLECTOR",
  ASSISTANT = "ASSISTANT",
}
